<template>
    <div class="custom-loading" v-if="customLoadingConfig.isOpen">
        <div class="flex-center flex-col" v-if="isFromApprove">    
            <p class="custom-loading-content text-center">
                We are recalculating your payrolls.
            </p>
            <p class="custom-loading-content text-center">
                Please reload this page after 5 minutes to make sure all data is calculated correctly.
            </p>
        </div>
        <div v-else>
            <p class="custom-loading-content text-center">Processing</p>
        </div>
        <p class="custom-loading-dot mb-base"></p>
    </div>
</template>

<script>
export default {
  name: "custom-loading",
  props: {
    customLoadingConfig: {
      type: Object,
      required: true,
    },
    isFromApprove: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.custom-loading {
  background-color: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: 0.2s ease;
  .custom-loading-dot, .custom-loading-content {
      width: 75%;
    color: white;
    // font: 300 4em/150% Impact;
    font-size: 20px;
    text-align: center;
    line-height: 2;
  }

  /* loading dots */

  .custom-loading-dot {
      transform: translateX(-15px);
      &::after {
        content: " .";
        // font-size: 150px;
        line-height: 0.8;
        font-size: 50px;
        animation: dots 1s steps(5, end) infinite;
      }
  }


  @keyframes dots {
    0%,
    20% {
      color: rgba(0, 0, 0, 0);
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
      color: white;
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    80%,
    100% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
    }
  }
}
</style>